export default class GoogleGeocoder {

    constructor() {
        this.geocoder = new google.maps.Geocoder();
        this.country = "CO";
        this.restrictions = {
            componentRestrictions: {
                country: this.country
            }
        }
    }

    geocode(address, success, error) {
        this.geocoder.geocode({ 'address': address, ...this.restrictions }, function (results, status) {
            if (status === 'OK') {
                success(results);
            } else {
                if (error) {
                    error(status);
                } else {
                    alert('Geocode was not successful for the following reason: ' + status);
                }
            }
        });
    }

    currentPosition(showPosition) {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(showPosition);
        } else {
            alert("Geolocation No esta disponible");
        }
    }

}